document.addEventListener('DOMContentLoaded', function () {
    const readMore = document.getElementById('read-more');
    const readLess = document.getElementById('read-less');
    const bioLess = document.getElementById('biography-less');
    const bioMore = document.getElementById('biography-more');
    const lastfilm = document.querySelector('.lastfilm');
    const biographie = document.querySelector('.biographie');

    if (readMore) {
        readMore.addEventListener('click', function () {
            bioLess.style.display = 'none';
            if (lastfilm) lastfilm.style.display = 'none';
            bioMore.style.display = 'block';
            biographie.classList.remove('col-sm-6', 'col-md-6', 'col-lg-6');
            biographie.classList.add('col-sm-12', 'col-md-12', 'col-lg-12');
        });
    }

    if (readLess) {
        readLess.addEventListener('click', function () {
            bioMore.style.display = 'none';
            bioLess.style.display = 'block';
            if (lastfilm) lastfilm.style.display = 'block';
            biographie.classList.remove('col-sm-12', 'col-md-12', 'col-lg-12');
            biographie.classList.add('col-sm-6', 'col-md-6', 'col-lg-6');
        });
    }

    const elImg = document.getElementsByClassName('filmography-item-img');
    if (typeof insertSrcAttrElImg === 'function') {
        insertSrcAttrElImg(elImg);
    }

    document.querySelectorAll('.section_toggler').forEach(toggler => {
        toggler.addEventListener('click', function () {
            const ccInner = this.closest('.cc-inner');
            const searchItems = ccInner.querySelector('.search-items');
            const toggleText = this.querySelector('.toggle_more');
            searchItems.classList.toggle('show-all');
            toggleText.textContent = searchItems.classList.contains('show-all') ? 'Afficher moins' : 'Afficher tout';
        });
    });
});
